// Staff Augmentation Services content
export const staffCategories = [
  {
    id: 'cloud',
    title: 'Cloud Professionals',
    icon: 'Cloud',
    tagline: 'Build secure, scalable, resilient cloud environments.',
    roles: [
      'Cloud Architects',
      'Cloud Consultants',
      'AWS Engineers',
      'Azure Engineers',
      'Google Cloud Engineers',
      'Cloud Migration Specialists',
      'Cloud Security Engineers',
      'Cloud Operations Engineers',
      'FinOps Specialists',
      'Cloud Infrastructure Engineers'
    ]
  },
  {
    id: 'ai',
    title: 'AI Experts',
    icon: 'Brain',
    tagline: 'Accelerate AI innovation with real-world business experience.',
    roles: [
      'AI Consultants',
      'Generative AI Engineers',
      'Machine Learning Engineers',
      'Data Scientists',
      'AI Solution Architects',
      'Prompt Engineers',
      'LLM Specialists',
      'RAG Developers',
      'AI Agent Developers',
      'MLOps Engineers',
      'AI Automation Specialists'
    ]
  },
  {
    id: 'devops',
    title: 'DevOps & Platform Engineering',
    icon: 'Cog',
    tagline: 'Ship faster with automation and operational excellence.',
    roles: [
      'DevOps Engineers',
      'Platform Engineers',
      'Site Reliability Engineers (SRE)',
      'Kubernetes Specialists',
      'Docker Engineers',
      'CI/CD Engineers',
      'Infrastructure as Code Engineers',
      'Automation Engineers',
      'Release Managers',
      'Observability Specialists'
    ]
  }
];

export const engagementModels = [
  {
    id: 'remote',
    title: 'Remote Talent',
    icon: 'Globe2',
    description: 'Access experienced professionals from anywhere in the world while reducing recruitment costs and accelerating delivery.'
  },
  {
    id: 'onsite',
    title: 'Onsite Resources',
    icon: 'Building',
    description: 'Deploy highly skilled consultants directly at your office for seamless collaboration with internal teams.'
  },
  {
    id: 'hybrid',
    title: 'Hybrid Engagement',
    icon: 'Blend',
    description: 'Combine onsite and remote resources for the ideal balance of flexibility, collaboration, and cost efficiency.'
  },
  {
    id: 'dedicated',
    title: 'Dedicated Teams',
    icon: 'Users',
    description: 'Build an entire cloud, AI, or DevOps team, managed and aligned with your long-term business objectives.'
  }
];

export const staffProcess = [
  { step: '01', title: 'Understand', description: 'We align with your stakeholders on project objectives, technical requirements, team structure, and business goals.' },
  { step: '02', title: 'Identify', description: 'We match your requirements with experienced professionals who have the right expertise and industry background.' },
  { step: '03', title: 'Validate', description: 'Candidates undergo technical validation and quality assurance before being presented for your review.' },
  { step: '04', title: 'Deploy', description: 'Selected professionals integrate seamlessly through remote, onsite, or hybrid engagement models.' },
  { step: '05', title: 'Support', description: 'We provide ongoing engagement management, performance monitoring, and continuous support.' }
];

export const staffWhyPartner = [
  { title: 'Highly Experienced Professionals', description: 'Years of hands-on experience delivering complex cloud, AI, and DevOps projects across industries.', icon: 'Trophy' },
  { title: 'Rigorous Talent Selection', description: 'Every professional undergoes technical, communication, and project-readiness evaluation before joining engagements.', icon: 'ShieldCheck' },
  { title: 'Rapid Deployment', description: 'Shorten hiring timelines and onboard qualified professionals in days, not months.', icon: 'Zap' },
  { title: 'Flexible Engagements', description: 'Scale up or down as priorities evolve — without the overhead of permanent hiring.', icon: 'Scaling' },
  { title: 'Business-Focused Delivery', description: 'Our professionals understand that technology exists to solve business challenges — not just technical ones.', icon: 'Target' },
  { title: 'Global Delivery Capability', description: 'Onsite consultants, remote experts, or distributed teams — wherever your projects operate.', icon: 'Globe2' }
];

export const staffBenefits = [
  'Access to highly experienced cloud, AI & DevOps talent',
  'Flexible onsite, remote & hybrid engagement models',
  'Faster hiring with reduced recruitment risk',
  'Enterprise-grade technical expertise',
  'Strong communication & collaboration skills',
  'Scalable staffing for projects of any size',
  'Long-term technology partnership approach',
  'Focus on quality, reliability & measurable outcomes'
];

export const staffIndustries = [
  { name: 'Retail & FMCG', icon: 'ShoppingBag' },
  { name: 'Banking & Financial Services', icon: 'Landmark' },
  { name: 'Real Estate & Construction', icon: 'Building2' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Telecommunications', icon: 'Radio' },
  { name: 'Logistics & Supply Chain', icon: 'Truck' },
  { name: 'Government', icon: 'Landmark' },
  { name: 'Energy & Utilities', icon: 'Zap' },
  { name: 'Media & Entertainment', icon: 'Film' }
];

export const staffFaqs = [
  { q: 'How quickly can you provide resources?', a: 'Depending on the role and skillset, qualified professionals can often be deployed within a few days, helping you accelerate timelines and reduce recruitment delays.' },
  { q: 'Do you provide remote and onsite consultants?', a: 'Yes. We offer remote, onsite, and hybrid staffing models based on your operational requirements and geographic preferences.' },
  { q: 'What experience do your consultants have?', a: 'Our professionals typically have several years of hands-on experience delivering enterprise cloud, AI, and DevOps projects, with expertise across modern technologies and industry best practices.' },
  { q: 'Can resources integrate with our existing teams?', a: 'Absolutely. Our consultants work as an extension of your organization — collaborating with your internal teams, following your processes, and contributing to your goals from day one.' }
];
